import { create } from 'zustand'
import { produce } from 'immer'

/**
 * Estado da conta WhatsApp oficial (Cloud API) da loja.
 *
 * status:
 *  disconnected — loja ainda não conectou o número
 *  connecting   — popup da Meta aberto / aguardando retorno
 *  syncing      — conectado, sincronizando contatos e histórico (janela de 24h)
 *  active       — conectado e disparando
 *  suspended    — pausado pela Meta (qualidade, pagamento, limite)
 *  error        — falha no cadastro
 */
export const useWhatsappOficial = create((set) => ({
  data: {
    loading: true,
    account: {
      status: 'disconnected',
      phoneNumber: null,
      displayName: null,
      displayNameStatus: null,
      qualityRating: null,
      messagingLimit: null,
      wabaId: null,
      phoneNumberId: null,
      isOnBizApp: null,
      connectedAt: null,
      syncedAt: null,
      hasPaymentMethod: false,
      error: null,
    },
    usage: {
      period: null,
      utility: { count: 0, cost: 0 },
      marketing: { count: 0, cost: 0 },
      service: { count: 0, cost: 0 },
      totalCost: 0,
      currency: 'BRL',
      updatedAt: null,
    },
  },
  actions: {
    setLoading: (loading) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.loading = loading
        }),
      ),
    setAccount: (account) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.account = { ...draft.data.account, ...account }
        }),
      ),
    setStatus: (status) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.account.status = status
        }),
      ),
    setUsage: (usage) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.usage = { ...draft.data.usage, ...usage }
        }),
      ),
  },
}))
